// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// import course css modules
import courseStyles from '../courseModuleStyles.css';

const AdminCourseQuickListItem = ({ course, match, study }) => {
  return (
    <Link to={`${match.url}/courses/${course._id}`} className="-item">
      {course.title}
      <div className="-icon">
        <i className="far fa-chevron-right"/>
      </div>
    </Link>

  )
}

AdminCourseQuickListItem.propTypes = {
  course: PropTypes.object.isRequired
  , study: PropTypes.object
}

export default withRouter(AdminCourseQuickListItem);



// WEBPACK FOOTER //
// modules/course/components/AdminCourseQuickListItem.js.jsx